import { render, staticRenderFns } from "./PackTasks.vue?vue&type=template&id=2478926c&scoped=true&"
import script from "./PackTasks.vue?vue&type=script&lang=js&"
export * from "./PackTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2478926c",
  null
  
)

export default component.exports